import {
  SET_RESUME_DATA,
  GET_RESUME_DATA,
  ADD_SKILLS,
  ADD_SKILLS_TITLE,
  CHECK_ALL_PUBLICATION,
  CHECK_ALL_PROJECT,
  CHECK_ALL_EDUCATION,
  CHECK_ALL_WORK,
  CHECK_PROJECT,
  CHECK_PIN,
  CHECK_ALL_PERSONAL_DETAIL,
  CHECK_INSTA,
  CHECK_WORK,
  CHECK_YT,
  CHECK_EXTRA,
  CHECK_PUBLIC,
  CHECK_CERT,
  CHECK_EDUCATION,
  ADD_SKILLS_RANGE,
  CHECK_FB,
  CHECK_LINKD,
  CHECK_TW,
  CHECK_DRIBBLE,
  CHECK_BE,
  SKILLS_RESET,
  SKILLS_DELETE,
  CHECK_PROFILE,
  CHECK_BIO,
  CHECK_FULLNAME,
  CHECK_ADDRESS,
  CHECK_PHONE,
  CHECK_EMAIL,
  UNCHECK_ALL_PERSONAL_DETAIL,
  ADD_HOBBIES,
  EDIT_HOBBIES,
  DELETE_HOBBIES,
  EDIT_SKILLS,
  DELETE_SKILLS,
  SET_HOBBILES_IMAGE,
  CHECK_ALL_CERTIFICATE,
  CHECK_ALL_EXTRA,
  GET_ENTIRE_USER_DATA_RESUME

} from "../constants";
const initialFormsData = {
  isPersonDetailsChecked: false,
  profilepicture: { status: false, profilepicture: "" },
  bio: { status: false, bio: "" },
  fullname: { status: false, fullname: "" },
  address: { status: false, address: "" },
  phone: { status: false, phone: "" },
  email: { status: false, email: "" },
  fb: { status: false, fb: "" },
  linkedin: { status: false, linkedin: "" },
  insta: { status: false, insta: "" },
  twitter: { status: false, twitter: "" },
  dribble: { status: false, dribble: "" },
  behance: { status: false, behance: "" },
  pintrest: { status: false, pintrest: "" },
  youtube: { status: false, youtube: "" },
  isEducationChecked: false,
  education: [],
  work: [],
  isWorkChecked: false,
  publication: [],
  ispublicationChecked: false,
  certificate: [],
  isCretificateChecked: false,
  extracur: [],
  isExtracurChecked: false,
  projects: [],
  isProjectChecked: false,
  skills: [],
  hobbies: [],
  isResumeCreated: false,
  editprofilepicture: { status: false, profilepicture: "" },
  editbio: { status: false, bio: "" },
  editfullname: { status: false, fullname: "" },
  editaddress: { status: false, address: "" },
  editphone: { status: false, phone: "" },
  editemail: { status: false, email: "" },
  editeducation: [],
  editwork: [],
  editpublication: [],
  editcertificate: [],
  editextracur: [],
  editprojects: [],
  editskills: [],
  hobbiesImage: [],
};

const resume = (state = initialFormsData, action) => {
  switch (action.type) {
    case GET_RESUME_DATA: {
      let resumeDataEdit = JSON.parse(action.payload)
      // console.log(resumeDataEdit)
      state.profilepicture = resumeDataEdit.profilepicture
      state.bio = resumeDataEdit.bio
      state.fullname = resumeDataEdit.fullname
      state.address = resumeDataEdit.address
      state.phone = resumeDataEdit.phone
      state.email = resumeDataEdit.email
      state.education = resumeDataEdit.education
      state.work = resumeDataEdit.work
      state.publication = resumeDataEdit.publication
      state.certificate = resumeDataEdit.certificate
      state.extracur = resumeDataEdit.extracur
      state.projects = resumeDataEdit.projects
      state.skills = resumeDataEdit.skills
      state.hobbies = resumeDataEdit.hobbies
      state.isPersonDetailsChecked = resumeDataEdit.isPersonDetailsChecked
      state.isEducationChecked = resumeDataEdit.isEducationChecked
      state.isWorkChecked = resumeDataEdit.isWorkChecked
      state.ispublicationChecked = resumeDataEdit.ispublicationChecked
      state.isCretificateChecked = resumeDataEdit.isCretificateChecked
      state.isExtracurChecked = resumeDataEdit.isExtracurChecked
      state.isProjectChecked = resumeDataEdit.isProjectChecked
      return {
        ...state,
      };
    }
    case SET_RESUME_DATA: {
      state.isResumeCreated = action.payload.resume_status
      state.profilepicture = {
        status: false,
        profilepicture: action.payload.profile_data.profile_photo,
      };
      state.bio = { status: false, bio: action.payload.profile_data.bio };
      state.fullname = {
        status: false,
        fullname:
          action.payload.profile_data.fname +
          " " +
          action.payload.profile_data.lname,
      };
      state.address = {
        status: false,
        address:
          action.payload.profile_data.city +
          " " +
          action.payload.profile_data.pincode +
          " " +
          action.payload.profile_data.state +
          " " +
          action.payload.profile_data.country,
      };
      state.phone = { status: false, phone: action.payload.profile_data.phone };
      state.email = { status: false, email: action.payload.profile_data.email };
      state.fb = { status: false, fb: action.payload.profile_data.fb };
      state.linkedin = {
        status: false,
        linkedin: action.payload.profile_data.linkdin,
      };
      state.insta = { status: false, insta: action.payload.profile_data.insta };
      state.twitter = {
        status: false,
        twitter: action.payload.profile_data.twitter,
      };
      state.dribble = {
        status: false,
        dribble: action.payload.profile_data.dribble,
      };
      state.behance = {
        status: false,
        behance: action.payload.profile_data.behance,
      };
      state.youtube = {
        status: false,
        youtube: action.payload.profile_data.youtube,
      };
      state.pintrest = {
        status: false,
        pintrest: action.payload.profile_data.pintrest,
      };
      state.education = action.payload.education_data.map((data) => {
        return { status: false, edu_data: data };
      });
      state.work = action.payload.work_data.map((data) => {
        return { status: false, work_data: data };
      });
      state.publication = action.payload.publication_data.map((data) => {
        return { status: false, publication_data: data };
      });
      state.certificate = action.payload.certificate_data.map((data) => {
        return { status: false, certificate_data: data };
      });
      state.extracur = action.payload.extracuricular_data.map((data) => {
        return { status: false, extracuricular_data: data };
      });
      state.projects = action.payload.projects_data.map((data) => {
        return { status: false, projects_data: data };
      });
      return {
        ...state,
      };
    }
    case ADD_SKILLS: {
      if (state.skills.length < 6) {
        state.skills.push({
          title: action.payload.title,
          skillRange: action.payload.rate,
        });
      } else {
        alert("Only 6 skills are allowed");
      }
      return {
        ...state,
      };
    }
    case ADD_SKILLS_TITLE: {
      state.skills[action.payload.id].title = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_SKILLS_RANGE: {
      state.skills[action.payload.id].skillRange = action.payload.value;
      return {
        ...state,
      };
    }
    case SKILLS_RESET: {
      state.skills[action.payload] = {
        title: "",
        skillRange: 0,
      };
      return {
        ...state,
      };
    }
    case DELETE_SKILLS: {
      state.skills.splice(action.payload, 1);
      return {
        ...state,
      };
    }
    case CHECK_PROFILE: {
      state.profilepicture = {
        ...state.profilepicture,
        status: !state.profilepicture.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_BIO: {
      state.bio = {
        ...state.bio,
        status: !state.bio.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_FULLNAME: {
      state.fullname = {
        ...state.fullname,
        status: !state.fullname.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_ADDRESS: {
      state.address = {
        ...state.address,
        status: !state.address.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_PHONE: {
      state.phone = {
        ...state.phone,
        status: !state.phone.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_EMAIL: {
      state.email = {
        ...state.email,
        status: !state.email.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_FB: {
      state.fb = {
        ...state.fb,
        status: !state.fb.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_LINKD: {
      state.linkedin = {
        ...state.linkedin,
        status: !state.linkedin.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_TW: {
      state.twitter = {
        ...state.twitter,
        status: !state.twitter.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_DRIBBLE: {
      state.dribble = {
        ...state.dribble,
        status: !state.dribble.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_BE: {
      state.behance = {
        ...state.behance,
        status: !state.behance.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_PIN: {
      state.pintrest = {
        ...state.pintrest,
        status: !state.pintrest.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_INSTA: {
      state.insta = {
        ...state.insta,
        status: !state.insta.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_YT: {
      state.youtube = {
        ...state.youtube,
        status: !state.youtube.status,
      };
      return {
        ...state,
      };
    }
    case CHECK_EDUCATION: {
      state.education[action.payload] = {
        ...state.education[action.payload],
        status: !state.education[action.payload].status,
      };
      return {
        ...state,
      };
    }
    case CHECK_WORK: {
      state.work[action.payload] = {
        ...state.work[action.payload],
        status: !state.work[action.payload].status,
      };
      return {
        ...state,
      };
    }
    case CHECK_PUBLIC: {
      state.publication[action.payload] = {
        ...state.publication[action.payload],
        status: !state.publication[action.payload].status,
      };
      return {
        ...state,
      };
    }
    case CHECK_CERT: {
      state.certificate[action.payload] = {
        ...state.certificate[action.payload],
        status: !state.certificate[action.payload].status,
      };
      return {
        ...state,
      };
    }
    case CHECK_EXTRA: {
      state.extracur[action.payload] = {
        ...state.extracur[action.payload],
        status: !state.extracur[action.payload].status,
      };
      return {
        ...state,
      };
    }
    case CHECK_PROJECT: {
      state.projects[action.payload] = {
        ...state.projects[action.payload],
        status: !state.projects[action.payload].status,
      };
      return {
        ...state,
      };
    }
    case CHECK_ALL_PERSONAL_DETAIL: {
      state.isPersonDetailsChecked = action.payload === 'CHECK' ? true : false
      state.profilepicture = { ...state.profilepicture, status: action.payload === 'CHECK' ? true : false };
      state.bio = { ...state.bio, status: action.payload === 'CHECK' ? true : false };
      state.fullname = { ...state.fullname, status: action.payload === 'CHECK' ? true : false };
      state.address = { ...state.address, status: action.payload === 'CHECK' ? true : false };
      state.phone = { ...state.phone, status: action.payload === 'CHECK' ? true : false };
      state.email = { ...state.email, status: action.payload === 'CHECK' ? true : false };
      return {
        ...state,
      };
    }
    case CHECK_ALL_EDUCATION: {
      state.isEducationChecked = action.payload === 'CHECK' ? true : false
      for (let i = 0; i < state.education.length; i++) {
        state.education[i].status = action.payload === 'CHECK' ? true : false;
      }
      return {
        ...state,
      };
    }
    case CHECK_ALL_WORK: {
      state.isWorkChecked = action.payload === 'CHECK' ? true : false
      for (let i = 0; i < state.work.length; i++) {
        state.work[i].status = action.payload === 'CHECK' ? true : false;
      }
      return {
        ...state,
      };
    }
    case CHECK_ALL_PUBLICATION: {
      state.ispublicationChecked = action.payload === 'CHECK' ? true : false
      for (let i = 0; i < state.publication.length; i++) {
        state.publication[i].status = action.payload === 'CHECK' ? true : false;
      }
      return {
        ...state,
      };
    }
    case CHECK_ALL_CERTIFICATE: {
      state.isCretificateChecked = action.payload === 'CHECK' ? true : false
      for (let i = 0; i < state.certificate.length; i++) {
        state.certificate[i].status = action.payload === 'CHECK' ? true : false;
      }
      return {
        ...state,
      };
    }
    case CHECK_ALL_EXTRA: {
      state.isExtracurChecked = action.payload === 'CHECK' ? true : false
      for (let i = 0; i < state.extracur.length; i++) {
        state.extracur[i].status = action.payload === 'CHECK' ? true : false;
      }
      return {
        ...state,
      };
    }
    case CHECK_ALL_PROJECT: {
      state.isProjectChecked = action.payload === 'CHECK' ? true : false
      for (let i = 0; i < state.projects.length; i++) {
        state.projects[i].status = action.payload === 'CHECK' ? true : false;
      }
      return {
        ...state,
      };
    }
    case ADD_HOBBIES: {
      state.hobbies.push({
        title: action.payload,
        icon: '',
      });
      return {
        ...state,
      };
    }
    case EDIT_HOBBIES: {
      state.hobbies[action.payload.id].title = action.payload.value.title
      return {
        ...state,
      };
    }
    case EDIT_SKILLS: {
      state.skills[action.payload.id].title = action.payload.value.title
      state.skills[action.payload.id].skillRange = action.payload.value.rate
      return {
        ...state,
      };
    }
    case DELETE_HOBBIES: {
      state.hobbies.splice(action.payload, 1)
      return {
        ...state,
      };
    }
    case SET_HOBBILES_IMAGE: {
      action.payload.forEach(element => {
        state.hobbiesImage.push({
          name: element.name,
          image: element.image,
          status: false,
        });
      });
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
export default resume;
